import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Button, DropdownMenu, DropdownMenuItem, Icon } from '@node-space/ui-components'
import { useMappedRoles } from 'hooks/useMappedRoles'
import { Card } from 'services/CardService'

interface CardDetailsActionsProps {
  card?: Card
  onFreeze?: () => void
  onCardDetailsClick?: () => void
}

export const CardDetailsActions: React.FC<CardDetailsActionsProps> = ({
  card,
  onFreeze,
  onCardDetailsClick,
}) => {
  const { t } = useTranslation()
  const permissions = useMappedRoles()
  const canEditCards = permissions?.cards?.canEdit
  const isFrozen = card?.status === 'FROZEN'
  const freezeButtonLabel = isFrozen
    ? t('customers.cardDetails.unfreeze')
    : t('customers.cardDetails.freeze')
  const freezeButtonDisabled =
    !card || card.status === 'BLOCKED' || card.status === 'CANCELLED' || !canEditCards

  return (
    <Box flex align="start" gap={8} className="self-end">
      {card?.status !== 'BLOCKED' && (
        <Button
          iconPosition="left"
          label={freezeButtonLabel}
          iconElement={<Icon name="Snowflake" />}
          variant="secondary"
          onClick={onFreeze}
          disabled={freezeButtonDisabled}
        >
          {freezeButtonLabel}
        </Button>
      )}

      {card ? (
        <DropdownMenu
          testId="card-action-menu"
          DropdownMenuItems={[
            <DropdownMenuItem
              key="card-details"
              LeadingIcon={<Icon name="CreditCard" />}
              onClick={onCardDetailsClick}
            >
              {t('customers.cardDetails.cardDetails')}
            </DropdownMenuItem>,
          ]}
        >
          <Button variant="ghost" iconElement={<Icon name="DotsThreeVerticalCustom" />} />
        </DropdownMenu>
      ) : (
        <Button variant="ghost" disabled iconElement={<Icon name="DotsThreeVerticalCustom" />} />
      )}
    </Box>
  )
}
